export * from './logController.service';
import { LogControllerService } from './logController.service';
export const APIS = [LogControllerService];
